export default "__VITE_ASSET__B71Lb80A__"